import apiSlice from '../api/api.slice';
import { IActivityFeedPage } from './activity.d';

const activityApiSlice = apiSlice
  .enhanceEndpoints({ addTagTypes: ['ActivityUnread'] })
  .injectEndpoints({
    endpoints: (builder) => ({
      // One cache entry for the whole feed; each cursor page appends to it.
      getActivityFeed: builder.query<IActivityFeedPage, string | undefined>({
        query: (cursor) => ({
          url: '/api/v1/activity',
          method: 'GET',
          params: cursor ? { cursor } : undefined,
        }),
        serializeQueryArgs: ({ endpointName }) => endpointName,
        merge: (cache, page, { arg }) => {
          if (!arg) return page;
          const known = new Set(cache.groups.map((group) => group.key));
          return {
            ...page,
            groups: [
              ...cache.groups,
              ...page.groups.filter((group) => !known.has(group.key)),
            ],
          };
        },
        forceRefetch: ({ currentArg, previousArg }) =>
          currentArg !== previousArg,
      }),
      getActivityUnreadCount: builder.query<number, void>({
        query: () => ({ url: '/api/v1/activity/unread-count', method: 'GET' }),
        transformResponse: (res: { count: number }) => res.count,
        providesTags: ['ActivityUnread'],
      }),
      markActivitySeen: builder.mutation<{ status: string }, string[]>({
        query: (ids) => ({
          url: '/api/v1/activity/seen',
          method: 'POST',
          body: { ids },
        }),
        invalidatesTags: ['ActivityUnread'],
      }),
    }),
  });

export const {
  useGetActivityFeedQuery,
  useGetActivityUnreadCountQuery,
  useMarkActivitySeenMutation,
} = activityApiSlice;
